export const CART_ADD_BASKET='CART_ADD_BASKET'
export const CART_REMOVE_BASKET='CART_REMOVE_BASKET'
export const CART_SAVE_SHIPPING_ADDRESS='CART_SAVE_SHIPPING_ADDRESS'
export const CART_PAYMENT_METHOD='CART_PAYMENT_METHOD'
